import React from "react";

const InfoPanelComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default InfoPanelComponent;
